import { type ReactNode } from 'react';

import { useBuyerIncentivesList } from './useBuyerIncentivesList';
import BuyerIncentiveCopy from '../BuyerIncentiveCopy';

export const useBuyerIncentivesMessages = ({
    useAll = false,
}: {
    useAll?: boolean;
} = {}): ReactNode[] => {
    const incentivesList = useBuyerIncentivesList({ useAll });

    return incentivesList.map(name => <BuyerIncentiveCopy name={name} />);
};
